import { Template } from './template.js'

const Menu = {
	template: Template,
	methods: {
		setLocale(locale) {
			// console.log('меняю');
			this.$emit("setLocale", locale);
		},
	}
}

export { Menu }


// WEBPACK FOOTER //
// ./src/app/js/components/menu/component.js